@if (displayDropDown) {
  <div>
    <select class="form-control form-select" name="serviceType"
      [(ngModel)]="selectedMeasuringPoint"
      (ngModelChange)="customerMeasuringPointChange($event)">
      @if (allowDropdownEmptySelection) {
        <option [ngValue]="null">-</option>
      }
      @for (customerMeasuringPoint of customerMeasuringPoints; track customerMeasuringPoint) {
        <option
        [ngValue]="customerMeasuringPoint">{{ customerMeasuringPoint['name' + this.crtLang.toUpperCase()] }}</option>
      }
    </select>
  </div>
}

@if (!displayDropDown) {
  <div class="input-group">
    <input type="text" class="form-control" pattern="{{textInputPattern}}"
      [class.is-invalid]="searchFailed"
      [ngbTypeahead]="search"
      [inputFormatter]="formatter"
      [resultFormatter]="formatter"
      [resultTemplate]="rtMeasurePoint"
      [disabled]="disabled"
      [(ngModel)]="selectedMeasuringPoint"
      (selectItem)="selectItem($event)"
      (focus)="searchSubject$.next($event.target['value'])"
      (keyup.enter)="searchSubject$.next($event.target.value)"
      placeholder="{{ 'measuringPoints.findMeasurePoint.placeholder' | translate }}"/>
      <span class="input-group-text">
        @if (!disabled && defaultMeasuringPoint) {
          <button class="btn btn-link btn-sm" type="button"
            title="{{'common.tooltip.undo' | translate}}"
            (click)="selectBackDefaultMeasuringPoint()">
            <fa-icon [icon]="icons.undo"></fa-icon>
          </button>
        }
        @if (!disabled && (selectedMeasuringPoint || searchText)) {
          <button class="btn btn-link btn-sm" type="button"
            title="{{ 'common.tooltip.erase' | translate }}"
            (click)="clearInput()">
            <fa-icon [icon]="icons.erase"></fa-icon>
          </button>
        }
      </span>
      @if (searchFailed) {
        <div class="invalid-feedback" translate="measuringPoints.findMeasurePoint.searchFailed"></div>
      }
      <ng-template #rtMeasurePoint let-measuringPoint="result" let-t="term">
        <ngb-highlight [result]="formatter(measuringPoint)" [term]="t"></ngb-highlight>
      </ng-template>
    </div>
  }
